import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { warningColor } from "assets/jss/material-dashboard-pro-react";

export const StyledTag = styled(Box)`
  font-size: 10px;
  font-weight: black;
  line-height: 100%;
  border-radius: 999px;
  border: 1px solid ${warningColor[0]};
  color: ${warningColor[0]};
  text-transform: uppercase;
  padding: 4px 8px;
`;

export const Divider = styled(Box)`
  border-bottom: 1px solid silver;
  margin-bottom: 1rem;
`;

export const Line = styled(Box)`
  display: flex;
  padding: 4px 0px;
  border-bottom: 1px solid #c0c0c071;
`;

export const DetailsContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledParagraph = styled(Typography)`
  font-weight: bold;
  font-size: 14px;
`;

export const StyledParagraphValue = styled(Typography)`
  font-size: 14px;
  margin-left: auto;
  margin-right: 0px;
`;

export const Title = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: black;
  text-decoration: none;
  font-weight: 300;
  margin-top: 20px;
  margin-bottom: 25px;
  min-height: 32px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;

  width: 100%;
  max-width: 200px;
  font-size: 20px;
`;
